import React, { useCallback } from "react";
import { Box, Button, ButtonGroup, CardCover, Divider, Grid, IconButton, Sheet, ToggleButtonGroup, Typography } from "@mui/joy";
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';
import RedoRoundedIcon from '@mui/icons-material/RedoRounded';
import FormatBoldRoundedIcon from '@mui/icons-material/FormatBoldRounded';
import FormatItalicRoundedIcon from '@mui/icons-material/FormatItalicRounded';
import FormatUnderlinedRoundedIcon from '@mui/icons-material/FormatUnderlinedRounded';
import FormatStrikethroughRoundedIcon from '@mui/icons-material/FormatStrikethroughRounded';
import StrikethroughSRoundedIcon from '@mui/icons-material/StrikethroughSRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import FormatIndentIncreaseRoundedIcon from '@mui/icons-material/FormatIndentIncreaseRounded';
import FormatIndentDecreaseRoundedIcon from '@mui/icons-material/FormatIndentDecreaseRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';

import { useCurrentEditor } from '@tiptap/react';

export const RichTextToolbar = ({ editor, menu = 'default'}) => {
    // const { editor } = useCurrentEditor();

    const setLink = useCallback(() => {
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl);

        // cancelled
        if (url === null) {
            return;
        }

        // empty
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }

        // update link
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
    }, [editor]);

    if (!editor) {
      return null;
    }

    return (
        <Box
            className="mm-rte-toolbar"
            sx={theme => ({
                // background: theme.palette.background.surface,// '#fff', // todo
                // var(--joy-palette-neutral-50, #FBFCFE)
                backgroundImage: `linear-gradient(180deg, ${theme.palette.neutral[50]} 40%, transparent 100%)`,
                p: 1,
                position: 'sticky',
                zIndex: 1,//'1000',
                top: 0,

                // rte wrapper
                '+ div': {
                    minHeight: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                }
            })}
        >
        <Sheet
          variant="outlined"
          sx={{
            // background: '#fff',
            borderRadius: 'sm',
            display: 'flex',
            gap: 2,
            p: 0.5,
            // m: 1,
            boxShadow: 'sm',
            // '--joy-palette-divider': 'black',
            // position: 'sticky',
            // zIndex: '1000',
            // top: '8px', // === m1
        }}
        //   ref={toolbarRef}
        >
            {menu === 'full' && (<>
            <ToggleButtonGroup
                size='sm'
                spacing={0.5}
            >
                <Button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                    aria-pressed={editor.isActive('heading', { level: 1 })}
                    aria-label='Insert header'
                    sx={{
                        // fontSize: 'sm'
                        paddingInline: 'var(--Button-paddingBlock, 0.4rem)',
                        // '--variant-outlinedColor': 'var(--Icon-color, var(--joy-palette-text-icon, var(--joy-palette-neutral-500, #636B74)))',
                    }}
                >
                    H1
                </Button>
                <Button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                    aria-pressed={editor.isActive('heading', { level: 2 })}
                    aria-label='Insert header'
                    sx={{
                        // fontSize: 'sm'
                        paddingInline: 'var(--Button-paddingBlock, 0.4rem)',
                        // '--variant-outlinedColor': 'var(--Icon-color, var(--joy-palette-text-icon, var(--joy-palette-neutral-500, #636B74)))',
                    }}
                >
                    H2
                </Button>
                <Button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
                    aria-pressed={editor.isActive('heading', { level: 3 })}
                    aria-label='Insert header'
                    sx={{
                        // fontSize: 'sm'
                        paddingInline: 'var(--Button-paddingBlock, 0.4rem)',
                        // '--variant-outlinedColor': 'var(--Icon-color, var(--joy-palette-text-icon, var(--joy-palette-neutral-500, #636B74)))',
                    }}
                >
                    H3
                </Button>
            </ToggleButtonGroup>
            <Divider orientation="vertical" sx={{ height: '1.5rem', alignSelf: 'center' }} />
            </>)}

            <ToggleButtonGroup
                size='sm'
                spacing={0.5}
            >
                <IconButton
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleBold()
                            .run()
                    }
                    aria-pressed={editor.isActive('bold')}
                    aria-label='Format bold'
                >
                    <FormatBoldRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleItalic()
                            .run()
                    }
                    aria-pressed={editor.isActive('italic')}
                    aria-label='Format italic'
                >
                    <FormatItalicRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleUnderline()
                            .run()
                    }
                    aria-pressed={editor.isActive('underline')}
                    aria-label='Format underline'
                >
                    <FormatUnderlinedRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().toggleStrike().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleStrike()
                            .run()
                    }
                    aria-pressed={editor.isActive('strike')}
                    aria-label='Format strikethrough'
                >
                    <StrikethroughSRoundedIcon/>
                </IconButton>
            </ToggleButtonGroup>

            <Divider orientation="vertical" sx={{ height: '1.5rem', alignSelf: 'center' }} />

            <ToggleButtonGroup
                size='sm'
                spacing={0.5}
            >
                {menu === 'full' && (<>
                {!editor.isActive('link') && (
                    <IconButton
                        onClick={setLink}
                        aria-label='Insert link'
                    >
                        <LinkRoundedIcon/>
                    </IconButton>
                )}
                {editor.isActive('link') && (
                    <IconButton
                    onClick={() => editor.chain().focus().unsetLink().run()}
                        aria-label='Remove link'
                    >
                        <LinkOffRoundedIcon/>
                    </IconButton>
                )}
                </>)}
                <IconButton
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                    aria-pressed={editor.isActive('bulletList')}
                    aria-label='Insert bullet list'
                >
                    <FormatListBulletedRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    aria-pressed={editor.isActive('orderedList')}
                    aria-label='Insert numbered list'
                >
                    <FormatListNumberedRoundedIcon/>
                </IconButton>

                {/*
                */}
                <IconButton
                    onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
                    disabled={!editor.can().sinkListItem('listItem')}
                    aria-label='Increase indent'
                >
                    <FormatIndentIncreaseRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().liftListItem('listItem').run()}
                    disabled={!editor.can().liftListItem('listItem')}
                    aria-label='Decrease indent'
                >
                    <FormatIndentDecreaseRoundedIcon/>
                </IconButton>
            </ToggleButtonGroup>

            <Divider orientation="vertical" sx={{ height: '1.5rem', alignSelf: 'center' }} />

            <ButtonGroup
                size='sm'
                spacing={0.5}
                sx={{}}
            >
                <IconButton
                    onClick={() => editor.chain().focus().undo().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .undo()
                            .run()
                    }
                    aria-label="Undo"
                    title='Undo'
                >
                    <UndoRoundedIcon/>
                </IconButton>
                <IconButton
                    onClick={() => editor.chain().focus().redo().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .redo()
                            .run()
                    }
                    aria-label="Redo"
                >
                    <RedoRoundedIcon/>
                </IconButton>
            </ButtonGroup>
        </Sheet>
        </Box>
    );
}
